import httpbaseURL from "../common/axios";
class SupplierPaymentMasterService {
  CreateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPaymentMaster/Create", doc);
  }
  UpdateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierPaymentMaster/Update", doc);
  }
  GetList() {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/List");
  }
  GetData(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/Get?PrepaymentID=" + doc);
  }
  DeleteData(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/SupplierPaymentMaster/Delete?PrepaymentID=" + doc
    );
  }
  GetOutStandingList(Id, HId, BId, FDate, TDate, StoreId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/GetOutstandingDetailsById?ID=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId + "&FromDate=" + FDate + "&ToDate=" + TDate + "&StoreId=" + StoreId);
  }
  GetPoPaymentsById(Id, HId, BId, StoreId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/GetPoPaymentsById?ID=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + StoreId);
  }
  GetInvoicePaymentsById(Id, HId, BId, StoreId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/GetInvoicePaymentsById?ID=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + StoreId);
  }

  GetBySupplierId(Id, HId, BId, StoreId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/GetBySupplierId?SupplierId=" + Id + "&HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + StoreId);
  }

  GetByPaymentId(Id) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentDetail/GetByPaymentId?PaymentID=" + Id);
  }

  UpdateApprovalStatus(Id, Status) {
    debugger
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierPaymentMaster/UpdateApprovalStatus?PaymentID=" + Id + "&IsApproved=" + Status);
  }
}
export default new SupplierPaymentMasterService();
